import React from 'react';
import { PreviewController } from './use-preview-controller';

//  Initialize with empty.  The Provider will fill this in once it gets the controller assembled
export const PreviewControllerContext = React.createContext<PreviewController>({} as PreviewController);

//  This exposes the controller to every child that wants to use it :-)
export const usePreviewProvider = () => React.useContext(PreviewControllerContext);
